module.exports = __webpack_public_path__ + "img/operationManage.5405204b.svg";